export default "<div class=\"parc\">\n    {{ParcsInComponent}}\n</div>\n";